import { radii } from "./radii";

/**
 * Button role tokens — house sizing extracted from legacy call sites
 * (36 = login button, 40 = table/header actions).
 */
export const buttonTokens = {
  height: { small: 32, medium: 36, large: 40 },
  padding: {
    small: "4px 12px",
    medium: "6px 16px",
    large: "8px 20px",
  },
  iconSize: { small: 16, medium: 20, large: 24 },
  borderRadius: radii.sm,
  disableElevation: true,
  textTransform: "none",
} as const;

export type TButtonTokenSize = keyof typeof buttonTokens.height;
